import { AirlinesCodes } from 'src/types'

const airlines: {
  [k in AirlinesCodes]: any
} = {
  AQ: require('src/assets/images/airlines/AQ.png'),
  GB: require('src/assets/images/airlines/GB.png'),
  X7: require('src/assets/images/airlines/X7.png'),
  A3: require('src/assets/images/airlines/A3.png'),
  EI: require('src/assets/images/airlines/EI.png'),
  JK: require('src/assets/images/airlines/JK.png'),
  NIG: require('src/assets/images/airlines/NIG.png'),
  '4A': require('src/assets/images/airlines/4A.png'),
  SU: require('src/assets/images/airlines/SU.png'),
  AR: require('src/assets/images/airlines/AR.png'),
  '3S': require('src/assets/images/airlines/3S.png'),
  VW: require('src/assets/images/airlines/VW.png'),
  AM: require('src/assets/images/airlines/AM.png'),
  '5D': require('src/assets/images/airlines/5D.png'),
  '6R': require('src/assets/images/airlines/6R.png'),
  VIZ: require('src/assets/images/airlines/VIZ.png'),
  J7: require('src/assets/images/airlines/J7.png'),
  '8U': require('src/assets/images/airlines/8U.png'),
  ZB: require('src/assets/images/airlines/ZB.png'),
  AH: require('src/assets/images/airlines/AH.png'),
  '6I': require('src/assets/images/airlines/6I.png'),
  G9: require('src/assets/images/airlines/G9.png'),
  KC: require('src/assets/images/airlines/KC.png'),
  CC: require('src/assets/images/airlines/CC.png'),
  UU: require('src/assets/images/airlines/UU.png'),
  BT: require('src/assets/images/airlines/BT.png'),
  KF: require('src/assets/images/airlines/KF.png'),
  BP: require('src/assets/images/airlines/BP.png'),
  BUR: require('src/assets/images/airlines/BUR.png'),
  '2J': require('src/assets/images/airlines/2J.png'),
  BX: require('src/assets/images/airlines/BX.png'),
  SM: require('src/assets/images/airlines/SM.png'),
  TY: require('src/assets/images/airlines/TY.png'),
  AC: require('src/assets/images/airlines/AC.png'),
  RV: require('src/assets/images/airlines/RV.png'),
  TX: require('src/assets/images/airlines/TX.png'),
  '2Q': require('src/assets/images/airlines/2Q.png'),
  '9H': require('src/assets/images/airlines/9H.png'),
  '3C': require('src/assets/images/airlines/3C.png'),
  CA: require('src/assets/images/airlines/CA.png'),
  CAO: require('src/assets/images/airlines/CAO.png'),
  '3E': require('src/assets/images/airlines/3E.png'),
  XK: require('src/assets/images/airlines/XK.png'),
  HF: require('src/assets/images/airlines/HF.png'),
  YN: require('src/assets/images/airlines/YN.png'),
  HD: require('src/assets/images/airlines/HD.png'),
  EN: require('src/assets/images/airlines/EN.png'),
  UX: require('src/assets/images/airlines/UX.png'),
  AF: require('src/assets/images/airlines/AF.png'),
  ZX: require('src/assets/images/airlines/ZX.png'),
  GL: require('src/assets/images/airlines/GL.png'),
  GT: require('src/assets/images/airlines/GT.png'),
  AHO: require('src/assets/images/airlines/AHO.png'),
  LD: require('src/assets/images/airlines/LD.png'),
  HT: require('src/assets/images/airlines/HT.png'),
  NY: require('src/assets/images/airlines/NY.png'),
  AI: require('src/assets/images/airlines/AI.png'),
  IX: require('src/assets/images/airlines/IX.png'),
  '3H': require('src/assets/images/airlines/3H.png'),
  IG: require('src/assets/images/airlines/IG.png'),
  K7: require('src/assets/images/airlines/K7.png'),
  JS: require('src/assets/images/airlines/JS.png'),
  AL: require('src/assets/images/airlines/AL.png'),
  '7Q': require('src/assets/images/airlines/7Q.png'),
  NX: require('src/assets/images/airlines/NX.png'),
  MD: require('src/assets/images/airlines/MD.png'),
  KM: require('src/assets/images/airlines/KM.png'),
  ZM: require('src/assets/images/airlines/ZM.png'),
  MK: require('src/assets/images/airlines/MK.png'),
  MV: require('src/assets/images/airlines/MV.png'),
  '9U': require('src/assets/images/airlines/9U.png'),
  SW: require('src/assets/images/airlines/SW.png'),
  NZ: require('src/assets/images/airlines/NZ.png'),
  PX: require('src/assets/images/airlines/PX.png'),
  '4N': require('src/assets/images/airlines/4N.png'),
  BFF: require('src/assets/images/airlines/BFF.png'),
  '7P': require('src/assets/images/airlines/7P.png'),
  P4: require('src/assets/images/airlines/P4.png'),
  PJ: require('src/assets/images/airlines/PJ.png'),
  HC: require('src/assets/images/airlines/HC.png'),
  RS: require('src/assets/images/airlines/RS.png'),
  HM: require('src/assets/images/airlines/HM.png'),
  VT: require('src/assets/images/airlines/VT.png'),
  TN: require('src/assets/images/airlines/TN.png'),
  TC: require('src/assets/images/airlines/TC.png'),
  TS: require('src/assets/images/airlines/TS.png'),
  '8C': require('src/assets/images/airlines/8C.png'),
  '3N': require('src/assets/images/airlines/3N.png'),
  NF: require('src/assets/images/airlines/NF.png'),
  AXY: require('src/assets/images/airlines/AXY.png'),
  UM: require('src/assets/images/airlines/UM.png'),
  '9T': require('src/assets/images/airlines/9T.png'),
  AK: require('src/assets/images/airlines/AK.png'),
  D7: require('src/assets/images/airlines/D7.png'),
  PA: require('src/assets/images/airlines/PA.png'),
  RU: require('src/assets/images/airlines/RU.png'),
  AIB: require('src/assets/images/airlines/AIB.png'),
  '4Y': require('src/assets/images/airlines/4Y.png'),
  SB: require('src/assets/images/airlines/SB.png'),
  AEG: require('src/assets/images/airlines/AEG.png'),
  ED: require('src/assets/images/airlines/ED.png'),
  '4Z': require('src/assets/images/airlines/4Z.png'),
  USC: require('src/assets/images/airlines/USC.png'),
  TL: require('src/assets/images/airlines/TL.png'),
  APC: require('src/assets/images/airlines/APC.png'),
  JU: require('src/assets/images/airlines/JU.png'),
  ASP: require('src/assets/images/airlines/ASP.png'),
  T6: require('src/assets/images/airlines/T6.png'),
  '9L': require('src/assets/images/airlines/9L.png'),
  NWG: require('src/assets/images/airlines/NWG.png'),
  PNX: require('src/assets/images/airlines/PNX.png'),
  AS: require('src/assets/images/airlines/AS.png'),
  KO: require('src/assets/images/airlines/KO.png'),
  AP: require('src/assets/images/airlines/AP.png'),
  '2B': require('src/assets/images/airlines/2B.png'),
  AZ: require('src/assets/images/airlines/AZ.png'),
  NH: require('src/assets/images/airlines/NH.png'),
  G4: require('src/assets/images/airlines/G4.png'),
  '9I': require('src/assets/images/airlines/9I.png'),
  TTX: require('src/assets/images/airlines/TTX.png'),
  QQ: require('src/assets/images/airlines/QQ.png'),
  '4W': require('src/assets/images/airlines/4W.png'),
  UJ: require('src/assets/images/airlines/UJ.png'),
  KH: require('src/assets/images/airlines/KH.png'),
  '5A': require('src/assets/images/airlines/5A.png'),
  HP: require('src/assets/images/airlines/HP.png'),
  Z8: require('src/assets/images/airlines/Z8.png'),
  AMV: require('src/assets/images/airlines/AMV.png'),
  AA: require('src/assets/images/airlines/AA.png'),
  A8: require('src/assets/images/airlines/A8.png'),
  M6: require('src/assets/images/airlines/M6.png'),
  GEO: require('src/assets/images/airlines/GEO.png'),
  DM: require('src/assets/images/airlines/DM.png'),
  OY: require('src/assets/images/airlines/OY.png'),
  '2G': require('src/assets/images/airlines/2G.png'),
  ADB: require('src/assets/images/airlines/ADB.png'),
  GP: require('src/assets/images/airlines/GP.png'),
  AZE: require('src/assets/images/airlines/AZE.png'),
  FG: require('src/assets/images/airlines/FG.png'),
  W3: require('src/assets/images/airlines/W3.png'),
  IZ: require('src/assets/images/airlines/IZ.png'),
  AG: require('src/assets/images/airlines/AG.png'),
  OZ: require('src/assets/images/airlines/OZ.png'),
  KP: require('src/assets/images/airlines/KP.png'),
  '3V': require('src/assets/images/airlines/3V.png'),
  '5O': require('src/assets/images/airlines/5O.png'),
  FAH: require('src/assets/images/airlines/FAH.png'),
  ABR: require('src/assets/images/airlines/ABR.png'),
  I3: require('src/assets/images/airlines/I3.png'),
  RC: require('src/assets/images/airlines/RC.png'),
  '5Y': require('src/assets/images/airlines/5Y.png'),
  KK: require('src/assets/images/airlines/KK.png'),
  V8: require('src/assets/images/airlines/V8.png'),
  LSK: require('src/assets/images/airlines/LSK.png'),
  GR: require('src/assets/images/airlines/GR.png'),
  HZ: require('src/assets/images/airlines/HZ.png'),
  AU: require('src/assets/images/airlines/AU.png'),
  OS: require('src/assets/images/airlines/OS.png'),
  ATV: require('src/assets/images/airlines/ATV.png'),
  YK: require('src/assets/images/airlines/YK.png'),
  ZR: require('src/assets/images/airlines/ZR.png'),
  AV: require('src/assets/images/airlines/AV.png'),
  QT: require('src/assets/images/airlines/QT.png'),
  '4B': require('src/assets/images/airlines/4B.png'),
  X9: require('src/assets/images/airlines/X9.png'),
  '9V': require('src/assets/images/airlines/9V.png'),
  J2: require('src/assets/images/airlines/J2.png'),
  A4: require('src/assets/images/airlines/A4.png'),
  S4: require('src/assets/images/airlines/S4.png'),
  AD: require('src/assets/images/airlines/AD.png'),
  ZF: require('src/assets/images/airlines/ZF.png'),
  QU: require('src/assets/images/airlines/QU.png'),
  ELH: require('src/assets/images/airlines/ELH.png'),
  BND: require('src/assets/images/airlines/BND.png'),
  RHD: require('src/assets/images/airlines/RHD.png'),
  DFL: require('src/assets/images/airlines/DFL.png'),
  UP: require('src/assets/images/airlines/UP.png'),
  QH: require('src/assets/images/airlines/QH.png'),
  PG: require('src/assets/images/airlines/PG.png'),
  '5B': require('src/assets/images/airlines/5B.png'),
  ID: require('src/assets/images/airlines/ID.png'),
  OD: require('src/assets/images/airlines/OD.png'),
  JV: require('src/assets/images/airlines/JV.png'),
  Z9: require('src/assets/images/airlines/Z9.png'),
  B2: require('src/assets/images/airlines/B2.png'),
  CH: require('src/assets/images/airlines/CH.png'),
  '8E': require('src/assets/images/airlines/8E.png'),
  BYA: require('src/assets/images/airlines/BYA.png'),
  '8H': require('src/assets/images/airlines/8H.png'),
  B3: require('src/assets/images/airlines/B3.png'),
  BG: require('src/assets/images/airlines/BG.png'),
  '3B': require('src/assets/images/airlines/3B.png'),
  NT: require('src/assets/images/airlines/NT.png'),
  '0B': require('src/assets/images/airlines/0B.png'),
  BZ: require('src/assets/images/airlines/BZ.png'),
  SI: require('src/assets/images/airlines/SI.png'),
  BV: require('src/assets/images/airlines/BV.png'),
  BBG: require('src/assets/images/airlines/BBG.png'),
  BO: require('src/assets/images/airlines/BO.png'),
  BOE: require('src/assets/images/airlines/BOE.png'),
  OB: require('src/assets/images/airlines/OB.png'),
  TF: require('src/assets/images/airlines/TF.png'),
  BAY: require('src/assets/images/airlines/BAY.png'),
  BHL: require('src/assets/images/airlines/BHL.png'),
  BTZ: require('src/assets/images/airlines/BTZ.png'),
  L9: require('src/assets/images/airlines/L9.png'),
  BA: require('src/assets/images/airlines/BA.png'),
  SN: require('src/assets/images/airlines/SN.png'),
  U4: require('src/assets/images/airlines/U4.png'),
  BFL: require('src/assets/images/airlines/BFL.png'),
  BKV: require('src/assets/images/airlines/BKV.png'),
  LB: require('src/assets/images/airlines/LB.png'),
  FB: require('src/assets/images/airlines/FB.png'),
  '1T': require('src/assets/images/airlines/1T.png'),
  UZ: require('src/assets/images/airlines/UZ.png'),
  JMP: require('src/assets/images/airlines/JMP.png'),
  VR: require('src/assets/images/airlines/VR.png'),
  '5C': require('src/assets/images/airlines/5C.png'),
  A7: require('src/assets/images/airlines/A7.png'),
  MO: require('src/assets/images/airlines/MO.png'),
  CMD: require('src/assets/images/airlines/CMD.png'),
  QC: require('src/assets/images/airlines/QC.png'),
  KR: require('src/assets/images/airlines/KR.png'),
  K6: require('src/assets/images/airlines/K6.png'),
  '5T': require('src/assets/images/airlines/5T.png'),
  PM: require('src/assets/images/airlines/PM.png'),
  '9K': require('src/assets/images/airlines/9K.png'),
  EGL: require('src/assets/images/airlines/EGL.png'),
  JD: require('src/assets/images/airlines/JD.png'),
  '8F': require('src/assets/images/airlines/8F.png'),
  CGF: require('src/assets/images/airlines/CGF.png'),
  W8: require('src/assets/images/airlines/W8.png'),
  P3: require('src/assets/images/airlines/P3.png'),
  CV: require('src/assets/images/airlines/CV.png'),
  C8: require('src/assets/images/airlines/C8.png'),
  BW: require('src/assets/images/airlines/BW.png'),
  V3: require('src/assets/images/airlines/V3.png'),
  IV: require('src/assets/images/airlines/IV.png'),
  CSJ: require('src/assets/images/airlines/CSJ.png'),
  KA: require('src/assets/images/airlines/KA.png'),
  CX: require('src/assets/images/airlines/CX.png'),
  CVK: require('src/assets/images/airlines/CVK.png'),
  KX: require('src/assets/images/airlines/KX.png'),
  '5J': require('src/assets/images/airlines/5J.png'),
  C2: require('src/assets/images/airlines/C2.png'),
  '5Z': require('src/assets/images/airlines/5Z.png'),
  '9M': require('src/assets/images/airlines/9M.png'),
  GM: require('src/assets/images/airlines/GM.png'),
  CE: require('src/assets/images/airlines/CE.png'),
  '6Q': require('src/assets/images/airlines/6Q.png'),
  HRT: require('src/assets/images/airlines/HRT.png'),
  HEM: require('src/assets/images/airlines/HEM.png'),
  HNL: require('src/assets/images/airlines/HNL.png'),
  HKS: require('src/assets/images/airlines/HKS.png'),
  EU: require('src/assets/images/airlines/EU.png'),
  CI: require('src/assets/images/airlines/CI.png'),
  CK: require('src/assets/images/airlines/CK.png'),
  MU: require('src/assets/images/airlines/MU.png'),
  G5: require('src/assets/images/airlines/G5.png'),
  CF: require('src/assets/images/airlines/CF.png'),
  CZ: require('src/assets/images/airlines/CZ.png'),
  KN: require('src/assets/images/airlines/KN.png'),
  PN: require('src/assets/images/airlines/PN.png'),
  OQ: require('src/assets/images/airlines/OQ.png'),
  NDL: require('src/assets/images/airlines/NDL.png'),
  QG: require('src/assets/images/airlines/QG.png'),
  WX: require('src/assets/images/airlines/WX.png'),
  GY: require('src/assets/images/airlines/GY.png'),
  MN: require('src/assets/images/airlines/MN.png'),
  CS: require('src/assets/images/airlines/CS.png'),
  MLM: require('src/assets/images/airlines/MLM.png'),
  FGD: require('src/assets/images/airlines/FGD.png'),
  DE: require('src/assets/images/airlines/DE.png'),
  LF: require('src/assets/images/airlines/LF.png'),
  V0: require('src/assets/images/airlines/V0.png'),
  CM: require('src/assets/images/airlines/CM.png'),
  CAT: require('src/assets/images/airlines/CAT.png'),
  XC: require('src/assets/images/airlines/XC.png'),
  SS: require('src/assets/images/airlines/SS.png'),
  Z7: require('src/assets/images/airlines/Z7.png'),
  OU: require('src/assets/images/airlines/OU.png'),
  CU: require('src/assets/images/airlines/CU.png'),
  RGN: require('src/assets/images/airlines/RGN.png'),
  CY: require('src/assets/images/airlines/CY.png'),
  OK: require('src/assets/images/airlines/OK.png'),
  CCD: require('src/assets/images/airlines/CCD.png'),
  '9J': require('src/assets/images/airlines/9J.png'),
  DX: require('src/assets/images/airlines/DX.png'),
  DCS: require('src/assets/images/airlines/DCS.png'),
  DF: require('src/assets/images/airlines/DF.png'),
  DL: require('src/assets/images/airlines/DL.png'),
  DPJ: require('src/assets/images/airlines/DPJ.png'),
  D0: require('src/assets/images/airlines/D0.png'),
  '3R': require('src/assets/images/airlines/3R.png'),
  DZ: require('src/assets/images/airlines/DZ.png'),
  R6: require('src/assets/images/airlines/R6.png'),
  KB: require('src/assets/images/airlines/KB.png'),
  DUB: require('src/assets/images/airlines/DUB.png'),
  FEI: require('src/assets/images/airlines/FEI.png'),
  ZE: require('src/assets/images/airlines/ZE.png'),
  T3: require('src/assets/images/airlines/T3.png'),
  VE: require('src/assets/images/airlines/VE.png'),
  U2: require('src/assets/images/airlines/U2.png'),
  '8J': require('src/assets/images/airlines/8J.png'),
  WK: require('src/assets/images/airlines/WK.png'),
  MS: require('src/assets/images/airlines/MS.png'),
  MSX: require('src/assets/images/airlines/MSX.png'),
  LY: require('src/assets/images/airlines/LY.png'),
  EL: require('src/assets/images/airlines/EL.png'),
  EMB: require('src/assets/images/airlines/EMB.png'),
  EK: require('src/assets/images/airlines/EK.png'),
  E4: require('src/assets/images/airlines/E4.png'),
  B8: require('src/assets/images/airlines/B8.png'),
  EG: require('src/assets/images/airlines/EG.png'),
  ES: require('src/assets/images/airlines/ES.png'),
  ET: require('src/assets/images/airlines/ET.png'),
  EY: require('src/assets/images/airlines/EY.png'),
  YU: require('src/assets/images/airlines/YU.png'),
  EW: require('src/assets/images/airlines/EW.png'),
  BR: require('src/assets/images/airlines/BR.png'),
  E9: require('src/assets/images/airlines/E9.png'),
  '5V': require('src/assets/images/airlines/5V.png'),
  XSR: require('src/assets/images/airlines/XSR.png'),
  EJM: require('src/assets/images/airlines/EJM.png'),
  XN: require('src/assets/images/airlines/XN.png'),
  '7A': require('src/assets/images/airlines/7A.png'),
  MG: require('src/assets/images/airlines/MG.png'),
  FE: require('src/assets/images/airlines/FE.png'),
  FX: require('src/assets/images/airlines/FX.png'),
  FJ: require('src/assets/images/airlines/FJ.png'),
  AY: require('src/assets/images/airlines/AY.png'),
  FY: require('src/assets/images/airlines/FY.png'),
  '7F': require('src/assets/images/airlines/7F.png'),
  FRN: require('src/assets/images/airlines/FRN.png'),
  F8: require('src/assets/images/airlines/F8.png'),
  FRF: require('src/assets/images/airlines/FRF.png'),
  W2: require('src/assets/images/airlines/W2.png'),
  LXJ: require('src/assets/images/airlines/LXJ.png'),
  FCK: require('src/assets/images/airlines/FCK.png'),
  OPT: require('src/assets/images/airlines/OPT.png'),
  FTL: require('src/assets/images/airlines/FTL.png'),
  '8W': require('src/assets/images/airlines/8W.png'),
  IF: require('src/assets/images/airlines/IF.png'),
  '4V': require('src/assets/images/airlines/4V.png'),
  OJ: require('src/assets/images/airlines/OJ.png'),
  '5F': require('src/assets/images/airlines/5F.png'),
  '5H': require('src/assets/images/airlines/5H.png'),
  F3: require('src/assets/images/airlines/F3.png'),
  BE: require('src/assets/images/airlines/BE.png'),
  FO: require('src/assets/images/airlines/FO.png'),
  '6W': require('src/assets/images/airlines/6W.png'),
  DW: require('src/assets/images/airlines/DW.png'),
  FZ: require('src/assets/images/airlines/FZ.png'),
  FT: require('src/assets/images/airlines/FT.png'),
  VP: require('src/assets/images/airlines/VP.png'),
  XY: require('src/assets/images/airlines/XY.png'),
  FP: require('src/assets/images/airlines/FP.png'),
  FH: require('src/assets/images/airlines/FH.png'),
  FRG: require('src/assets/images/airlines/FRG.png'),
  BF: require('src/assets/images/airlines/BF.png'),
  F9: require('src/assets/images/airlines/F9.png'),
  JH: require('src/assets/images/airlines/JH.png'),
  FU: require('src/assets/images/airlines/FU.png'),
  GAJ: require('src/assets/images/airlines/GAJ.png'),
  GMA: require('src/assets/images/airlines/GMA.png'),
  GA: require('src/assets/images/airlines/GA.png'),
  '4G': require('src/assets/images/airlines/4G.png'),
  A9: require('src/assets/images/airlines/A9.png'),
  G8: require('src/assets/images/airlines/G8.png'),
  '6G': require('src/assets/images/airlines/6G.png'),
  G3: require('src/assets/images/airlines/G3.png'),
  Y5: require('src/assets/images/airlines/Y5.png'),
  G6: require('src/assets/images/airlines/G6.png'),
  YR: require('src/assets/images/airlines/YR.png'),
  CN: require('src/assets/images/airlines/CN.png'),
  ZK: require('src/assets/images/airlines/ZK.png'),
  ZG: require('src/assets/images/airlines/ZG.png'),
  GF: require('src/assets/images/airlines/GF.png'),
  GX: require('src/assets/images/airlines/GX.png'),
  HR: require('src/assets/images/airlines/HR.png'),
  HU: require('src/assets/images/airlines/HU.png'),
  HGR: require('src/assets/images/airlines/HGR.png'),
  HA: require('src/assets/images/airlines/HA.png'),
  NS: require('src/assets/images/airlines/NS.png'),
  HHE: require('src/assets/images/airlines/HHE.png'),
  HSO: require('src/assets/images/airlines/HSO.png'),
  '2L': require('src/assets/images/airlines/2L.png'),
  '5K': require('src/assets/images/airlines/5K.png'),
  H9: require('src/assets/images/airlines/H9.png'),
  OI: require('src/assets/images/airlines/OI.png'),
  HX: require('src/assets/images/airlines/HX.png'),
  UO: require('src/assets/images/airlines/UO.png'),
  HTM: require('src/assets/images/airlines/HTM.png'),
  MR: require('src/assets/images/airlines/MR.png'),
  '0Q': require('src/assets/images/airlines/0Q.png'),
  I4: require('src/assets/images/airlines/I4.png'),
  II: require('src/assets/images/airlines/II.png'),
  IB: require('src/assets/images/airlines/IB.png'),
  I2: require('src/assets/images/airlines/I2.png'),
  FW: require('src/assets/images/airlines/FW.png'),
  FI: require('src/assets/images/airlines/FI.png'),
  '6E': require('src/assets/images/airlines/6E.png'),
  JY: require('src/assets/images/airlines/JY.png'),
  '4O': require('src/assets/images/airlines/4O.png'),
  IO: require('src/assets/images/airlines/IO.png'),
  IR: require('src/assets/images/airlines/IR.png'),
  B9: require('src/assets/images/airlines/B9.png'),
  EP: require('src/assets/images/airlines/EP.png'),
  IA: require('src/assets/images/airlines/IA.png'),
  '6H': require('src/assets/images/airlines/6H.png'),
  I8: require('src/assets/images/airlines/I8.png'),
  XM: require('src/assets/images/airlines/XM.png'),
  JM: require('src/assets/images/airlines/JM.png'),
  '3X': require('src/assets/images/airlines/3X.png'),
  JL: require('src/assets/images/airlines/JL.png'),
  NU: require('src/assets/images/airlines/NU.png'),
  J9: require('src/assets/images/airlines/J9.png'),
  QD: require('src/assets/images/airlines/QD.png'),
  '7C': require('src/assets/images/airlines/7C.png'),
  JF: require('src/assets/images/airlines/JF.png'),
  J4: require('src/assets/images/airlines/J4.png'),
  LS: require('src/assets/images/airlines/LS.png'),
  B6: require('src/assets/images/airlines/B6.png'),
  JA: require('src/assets/images/airlines/JA.png'),
  JQ: require('src/assets/images/airlines/JQ.png'),
  RSP: require('src/assets/images/airlines/RSP.png'),
  WU: require('src/assets/images/airlines/WU.png'),
  RY: require('src/assets/images/airlines/RY.png'),
  LJ: require('src/assets/images/airlines/LJ.png'),
  R5: require('src/assets/images/airlines/R5.png'),
  ENZ: require('src/assets/images/airlines/ENZ.png'),
  XE: require('src/assets/images/airlines/XE.png'),
  HO: require('src/assets/images/airlines/HO.png'),
  '8K': require('src/assets/images/airlines/8K.png'),
  KAY: require('src/assets/images/airlines/KAY.png'),
  K4: require('src/assets/images/airlines/K4.png'),
  K9: require('src/assets/images/airlines/K9.png'),
  RQ: require('src/assets/images/airlines/RQ.png'),
  NV: require('src/assets/images/airlines/NV.png'),
  FK: require('src/assets/images/airlines/FK.png'),
  M5: require('src/assets/images/airlines/M5.png'),
  KQ: require('src/assets/images/airlines/KQ.png'),
  KG: require('src/assets/images/airlines/KG.png'),
  KW: require('src/assets/images/airlines/KW.png'),
  KHO: require('src/assets/images/airlines/KHO.png'),
  Y9: require('src/assets/images/airlines/Y9.png'),
  KL: require('src/assets/images/airlines/KL.png'),
  KE: require('src/assets/images/airlines/KE.png'),
  KY: require('src/assets/images/airlines/KY.png'),
  KU: require('src/assets/images/airlines/KU.png'),
  B0: require('src/assets/images/airlines/B0.png'),
  TM: require('src/assets/images/airlines/TM.png'),
  LQ: require('src/assets/images/airlines/LQ.png'),
  QV: require('src/assets/images/airlines/QV.png'),
  LK: require('src/assets/images/airlines/LK.png'),
  QL: require('src/assets/images/airlines/QL.png'),
  JJ: require('src/assets/images/airlines/LA.png'),
  LA: require('src/assets/images/airlines/LA.png'),
  UC: require('src/assets/images/airlines/UC.png'),
  OE: require('src/assets/images/airlines/OE.png'),
  VK: require('src/assets/images/airlines/VK.png'),
  LI: require('src/assets/images/airlines/LI.png'),
  LN: require('src/assets/images/airlines/LN.png'),
  YL: require('src/assets/images/airlines/YL.png'),
  JT: require('src/assets/images/airlines/JT.png'),
  LM: require('src/assets/images/airlines/LM.png'),
  LT: require('src/assets/images/airlines/LT.png'),
  GJ: require('src/assets/images/airlines/GJ.png'),
  LO: require('src/assets/images/airlines/LO.png'),
  '8L': require('src/assets/images/airlines/8L.png'),
  LH: require('src/assets/images/airlines/LH.png'),
  GEC: require('src/assets/images/airlines/GEC.png'),
  LTR: require('src/assets/images/airlines/LTR.png'),
  LW: require('src/assets/images/airlines/LW.png'),
  LG: require('src/assets/images/airlines/LG.png'),
  W5: require('src/assets/images/airlines/W5.png'),
  '3W': require('src/assets/images/airlines/3W.png'),
  MH: require('src/assets/images/airlines/MH.png'),
  Q2: require('src/assets/images/airlines/Q2.png'),
  AE: require('src/assets/images/airlines/AE.png'),
  JE: require('src/assets/images/airlines/JE.png'),
  '7Y': require('src/assets/images/airlines/7Y.png'),
  NR: require('src/assets/images/airlines/NR.png'),
  '7M': require('src/assets/images/airlines/7M.png'),
  MP: require('src/assets/images/airlines/MP.png'),
  M7: require('src/assets/images/airlines/M7.png'),
  MY: require('src/assets/images/airlines/MY.png'),
  L6: require('src/assets/images/airlines/L6.png'),
  MAX: require('src/assets/images/airlines/MAX.png'),
  SUM: require('src/assets/images/airlines/SUM.png'),
  ME: require('src/assets/images/airlines/ME.png'),
  VL: require('src/assets/images/airlines/VL.png'),
  JI: require('src/assets/images/airlines/JI.png'),
  YV: require('src/assets/images/airlines/YV.png'),
  LL: require('src/assets/images/airlines/LL.png'),
  OM: require('src/assets/images/airlines/OM.png'),
  '8G': require('src/assets/images/airlines/8G.png'),
  MWT: require('src/assets/images/airlines/MWT.png'),
  IM: require('src/assets/images/airlines/IM.png'),
  MJF: require('src/assets/images/airlines/MJF.png'),
  MB: require('src/assets/images/airlines/MB.png'),
  MW: require('src/assets/images/airlines/MW.png'),
  QM: require('src/assets/images/airlines/QM.png'),
  YM: require('src/assets/images/airlines/YM.png'),
  MAL: require('src/assets/images/airlines/MAL.png'),
  M9: require('src/assets/images/airlines/M9.png'),
  '8M': require('src/assets/images/airlines/8M.png'),
  UB: require('src/assets/images/airlines/UB.png'),
  MJ: require('src/assets/images/airlines/MJ.png'),
  IN: require('src/assets/images/airlines/IN.png'),
  N8: require('src/assets/images/airlines/N8.png'),
  JTE: require('src/assets/images/airlines/JTE.png'),
  ON: require('src/assets/images/airlines/ON.png'),
  NO: require('src/assets/images/airlines/NO.png'),
  RA: require('src/assets/images/airlines/RA.png'),
  NA: require('src/assets/images/airlines/NA.png'),
  NE: require('src/assets/images/airlines/NE.png'),
  NJE: require('src/assets/images/airlines/NJE.png'),
  '1I': require('src/assets/images/airlines/1I.png'),
  EJ: require('src/assets/images/airlines/EJ.png'),
  E3: require('src/assets/images/airlines/E3.png'),
  EXT: require('src/assets/images/airlines/EXT.png'),
  NP: require('src/assets/images/airlines/NP.png'),
  KZ: require('src/assets/images/airlines/KZ.png'),
  DD: require('src/assets/images/airlines/DD.png'),
  XW: require('src/assets/images/airlines/XW.png'),
  N5: require('src/assets/images/airlines/N5.png'),
  NHX: require('src/assets/images/airlines/NHX.png'),
  Y7: require('src/assets/images/airlines/Y7.png'),
  N4: require('src/assets/images/airlines/N4.png'),
  NCB: require('src/assets/images/airlines/NCB.png'),
  NFA: require('src/assets/images/airlines/NFA.png'),
  NC: require('src/assets/images/airlines/NC.png'),
  NHC: require('src/assets/images/airlines/NHC.png'),
  J3: require('src/assets/images/airlines/J3.png'),
  DY: require('src/assets/images/airlines/DY.png'),
  BJ: require('src/assets/images/airlines/BJ.png'),
  O9: require('src/assets/images/airlines/O9.png'),
  N9: require('src/assets/images/airlines/N9.png'),
  VQ: require('src/assets/images/airlines/VQ.png'),
  BK: require('src/assets/images/airlines/BK.png'),
  OA: require('src/assets/images/airlines/OA.png'),
  OLY: require('src/assets/images/airlines/OLY.png'),
  WY: require('src/assets/images/airlines/WY.png'),
  '8Q': require('src/assets/images/airlines/8Q.png'),
  '6O': require('src/assets/images/airlines/6O.png'),
  PUL: require('src/assets/images/airlines/PUL.png'),
  OXF: require('src/assets/images/airlines/OXF.png'),
  '8P': require('src/assets/images/airlines/8P.png'),
  PK: require('src/assets/images/airlines/PK.png'),
  PB: require('src/assets/images/airlines/PB.png'),
  '8Y': require('src/assets/images/airlines/8Y.png'),
  ZP: require('src/assets/images/airlines/ZP.png'),
  P6: require('src/assets/images/airlines/P6.png'),
  '2Z': require('src/assets/images/airlines/2Z.png'),
  MM: require('src/assets/images/airlines/MM.png'),
  EO: require('src/assets/images/airlines/EO.png'),
  PC: require('src/assets/images/airlines/PC.png'),
  PFY: require('src/assets/images/airlines/PFY.png'),
  KS: require('src/assets/images/airlines/KS.png'),
  PE: require('src/assets/images/airlines/PE.png'),
  YP: require('src/assets/images/airlines/YP.png'),
  P9: require('src/assets/images/airlines/P9.png'),
  PR: require('src/assets/images/airlines/PR.png'),
  CNS: require('src/assets/images/airlines/CNS.png'),
  PU: require('src/assets/images/airlines/PU.png'),
  CG: require('src/assets/images/airlines/CG.png'),
  DP: require('src/assets/images/airlines/DP.png'),
  PO: require('src/assets/images/airlines/PO.png'),
  LPR: require('src/assets/images/airlines/LPR.png'),
  OL: require('src/assets/images/airlines/OL.png'),
  PD: require('src/assets/images/airlines/PD.png'),
  M4: require('src/assets/images/airlines/M4.png'),
  PW: require('src/assets/images/airlines/PW.png'),
  PWA: require('src/assets/images/airlines/PWA.png'),
  PVG: require('src/assets/images/airlines/PVG.png'),
  QF: require('src/assets/images/airlines/QF.png'),
  QLK: require('src/assets/images/airlines/QLK.png'),
  QR: require('src/assets/images/airlines/QR.png'),
  QB: require('src/assets/images/airlines/QB.png'),
  QW: require('src/assets/images/airlines/QW.png'),
  LBQ: require('src/assets/images/airlines/LBQ.png'),
  MTL: require('src/assets/images/airlines/MTL.png'),
  '7H': require('src/assets/images/airlines/7H.png'),
  TH: require('src/assets/images/airlines/TH.png'),
  WZ: require('src/assets/images/airlines/WZ.png'),
  RX: require('src/assets/images/airlines/RX.png'),
  ZL: require('src/assets/images/airlines/ZL.png'),
  EE: require('src/assets/images/airlines/EE.png'),
  YX: require('src/assets/images/airlines/YX.png'),
  FV: require('src/assets/images/airlines/FV.png'),
  RG: require('src/assets/images/airlines/RG.png'),
  AT: require('src/assets/images/airlines/AT.png'),
  BI: require('src/assets/images/airlines/BI.png'),
  RFJ: require('src/assets/images/airlines/RFJ.png'),
  RL: require('src/assets/images/airlines/RL.png'),
  RJ: require('src/assets/images/airlines/RJ.png'),
  DR: require('src/assets/images/airlines/DR.png'),
  '7R': require('src/assets/images/airlines/7R.png'),
  '5R': require('src/assets/images/airlines/5R.png'),
  WB: require('src/assets/images/airlines/WB.png'),
  '7S': require('src/assets/images/airlines/7S.png'),
  FR: require('src/assets/images/airlines/FR.png'),
  RAC: require('src/assets/images/airlines/RAC.png'),
  S7: require('src/assets/images/airlines/S7.png'),
  XZ: require('src/assets/images/airlines/XZ.png'),
  FA: require('src/assets/images/airlines/FA.png'),
  '4Q': require('src/assets/images/airlines/4Q.png'),
  OV: require('src/assets/images/airlines/OV.png'),
  RZ: require('src/assets/images/airlines/RZ.png'),
  SK: require('src/assets/images/airlines/SK.png'),
  SP: require('src/assets/images/airlines/SP.png'),
  '9R': require('src/assets/images/airlines/9R.png'),
  SV: require('src/assets/images/airlines/SV.png'),
  '6S': require('src/assets/images/airlines/6S.png'),
  DV: require('src/assets/images/airlines/DV.png'),
  TR: require('src/assets/images/airlines/TR.png'),
  BB: require('src/assets/images/airlines/BB.png'),
  IS: require('src/assets/images/airlines/IS.png'),
  ER: require('src/assets/images/airlines/ER.png'),
  WV: require('src/assets/images/airlines/WV.png'),
  D2: require('src/assets/images/airlines/D2.png'),
  O3: require('src/assets/images/airlines/O3.png'),
  SC: require('src/assets/images/airlines/SC.png'),
  FM: require('src/assets/images/airlines/FM.png'),
  ZH: require('src/assets/images/airlines/ZH.png'),
  '3U': require('src/assets/images/airlines/3U.png'),
  P8: require('src/assets/images/airlines/P8.png'),
  '7L': require('src/assets/images/airlines/7L.png'),
  MI: require('src/assets/images/airlines/MI.png'),
  '3M': require('src/assets/images/airlines/3M.png'),
  SQ: require('src/assets/images/airlines/SQ.png'),
  SQC: require('src/assets/images/airlines/SQC.png'),
  HMF: require('src/assets/images/airlines/HMF.png'),
  H2: require('src/assets/images/airlines/H2.png'),
  ZA: require('src/assets/images/airlines/ZA.png'),
  Q7: require('src/assets/images/airlines/Q7.png'),
  GQ: require('src/assets/images/airlines/GQ.png'),
  GG: require('src/assets/images/airlines/GG.png'),
  IOS: require('src/assets/images/airlines/IOS.png'),
  M8: require('src/assets/images/airlines/M8.png'),
  SLQ: require('src/assets/images/airlines/SLQ.png'),
  BC: require('src/assets/images/airlines/BC.png'),
  SYB: require('src/assets/images/airlines/SYB.png'),
  TE: require('src/assets/images/airlines/TE.png'),
  QN: require('src/assets/images/airlines/QN.png'),
  PQ: require('src/assets/images/airlines/PQ.png'),
  OO: require('src/assets/images/airlines/OO.png'),
  '5N': require('src/assets/images/airlines/5N.png'),
  '6Y': require('src/assets/images/airlines/6Y.png'),
  QS: require('src/assets/images/airlines/QS.png'),
  '6J': require('src/assets/images/airlines/6J.png'),
  SOP: require('src/assets/images/airlines/SOP.png'),
  SZ: require('src/assets/images/airlines/SZ.png'),
  SOR: require('src/assets/images/airlines/SOR.png'),
  S8: require('src/assets/images/airlines/S8.png'),
  SA: require('src/assets/images/airlines/SA.png'),
  '9S': require('src/assets/images/airlines/9S.png'),
  WN: require('src/assets/images/airlines/WN.png'),
  SG: require('src/assets/images/airlines/SG.png'),
  NK: require('src/assets/images/airlines/NK.png'),
  '9C': require('src/assets/images/airlines/9C.png'),
  IJ: require('src/assets/images/airlines/IJ.png'),
  UL: require('src/assets/images/airlines/UL.png'),
  SJ: require('src/assets/images/airlines/SJ.png'),
  PV: require('src/assets/images/airlines/PV.png'),
  DJ: require('src/assets/images/airlines/DJ.png'),
  '7G': require('src/assets/images/airlines/7G.png'),
  Q4: require('src/assets/images/airlines/Q4.png'),
  RE: require('src/assets/images/airlines/RE.png'),
  NUK: require('src/assets/images/airlines/NUK.png'),
  FFD: require('src/assets/images/airlines/FFD.png'),
  SD: require('src/assets/images/airlines/SD.png'),
  '9X': require('src/assets/images/airlines/9X.png'),
  SY: require('src/assets/images/airlines/SY.png'),
  EZ: require('src/assets/images/airlines/EZ.png'),
  SR: require('src/assets/images/airlines/SR.png'),
  XQ: require('src/assets/images/airlines/XQ.png'),
  CNK: require('src/assets/images/airlines/CNK.png'),
  WG: require('src/assets/images/airlines/WG.png'),
  Y8: require('src/assets/images/airlines/Y8.png'),
  URF: require('src/assets/images/airlines/URF.png'),
  PY: require('src/assets/images/airlines/PY.png'),
  WQ: require('src/assets/images/airlines/WQ.png'),
  WT: require('src/assets/images/airlines/WT.png'),
  MDF: require('src/assets/images/airlines/MDF.png'),
  LX: require('src/assets/images/airlines/LX.png'),
  SAZ: require('src/assets/images/airlines/SAZ.png'),
  WO: require('src/assets/images/airlines/WO.png'),
  AWU: require('src/assets/images/airlines/AWU.png'),
  RB: require('src/assets/images/airlines/RB.png'),
  TW: require('src/assets/images/airlines/TW.png'),
  DT: require('src/assets/images/airlines/DT.png'),
  HH: require('src/assets/images/airlines/HH.png'),
  TI: require('src/assets/images/airlines/TI.png'),
  EQ: require('src/assets/images/airlines/EQ.png'),
  TP: require('src/assets/images/airlines/TP.png'),
  NI: require('src/assets/images/airlines/NI.png'),
  YQ: require('src/assets/images/airlines/YQ.png'),
  '3T': require('src/assets/images/airlines/3T.png'),
  RO: require('src/assets/images/airlines/RO.png'),
  SF: require('src/assets/images/airlines/SF.png'),
  U9: require('src/assets/images/airlines/U9.png'),
  X5: require('src/assets/images/airlines/X5.png'),
  TG: require('src/assets/images/airlines/TG.png'),
  SL: require('src/assets/images/airlines/SL.png'),
  WE: require('src/assets/images/airlines/WE.png'),
  VZ: require('src/assets/images/airlines/VZ.png'),
  MT: require('src/assets/images/airlines/MT.png'),
  GS: require('src/assets/images/airlines/GS.png'),
  TV: require('src/assets/images/airlines/TV.png'),
  TT: require('src/assets/images/airlines/TT.png'),
  IT: require('src/assets/images/airlines/IT.png'),
  ZT: require('src/assets/images/airlines/ZT.png'),
  TFX: require('src/assets/images/airlines/TFX.png'),
  C3: require('src/assets/images/airlines/C3.png'),
  TJ: require('src/assets/images/airlines/TJ.png'),
  Q8: require('src/assets/images/airlines/Q8.png'),
  TGY: require('src/assets/images/airlines/TGY.png'),
  TMW: require('src/assets/images/airlines/TMW.png'),
  AX: require('src/assets/images/airlines/AX.png'),
  HV: require('src/assets/images/airlines/HV.png'),
  KTB: require('src/assets/images/airlines/KTB.png'),
  '8B': require('src/assets/images/airlines/8B.png'),
  '4T': require('src/assets/images/airlines/4T.png'),
  IL: require('src/assets/images/airlines/IL.png'),
  '2T': require('src/assets/images/airlines/2T.png'),
  X3: require('src/assets/images/airlines/X3.png'),
  TU: require('src/assets/images/airlines/TU.png'),
  UG: require('src/assets/images/airlines/UG.png'),
  TK: require('src/assets/images/airlines/TK.png'),
  T5: require('src/assets/images/airlines/T5.png'),
  TRK: require('src/assets/images/airlines/TRK.png'),
  T9: require('src/assets/images/airlines/T9.png'),
  U8: require('src/assets/images/airlines/U8.png'),
  T7: require('src/assets/images/airlines/T7.png'),
  UKL: require('src/assets/images/airlines/UKL.png'),
  PS: require('src/assets/images/airlines/PS.png'),
  GO: require('src/assets/images/airlines/GO.png'),
  UE: require('src/assets/images/airlines/UE.png'),
  B7: require('src/assets/images/airlines/B7.png'),
  UW: require('src/assets/images/airlines/UW.png'),
  UA: require('src/assets/images/airlines/UA.png'),
  UNO: require('src/assets/images/airlines/UNO.png'),
  '5X': require('src/assets/images/airlines/5X.png'),
  UD: require('src/assets/images/airlines/UD.png'),
  U6: require('src/assets/images/airlines/U6.png'),
  UQ: require('src/assets/images/airlines/UQ.png'),
  BS: require('src/assets/images/airlines/BS.png'),
  JUS: require('src/assets/images/airlines/JUS.png'),
  UT: require('src/assets/images/airlines/UT.png'),
  RT: require('src/assets/images/airlines/RT.png'),
  HY: require('src/assets/images/airlines/HY.png'),
  V9: require('src/assets/images/airlines/V9.png'),
  JW: require('src/assets/images/airlines/JW.png'),
  '0V': require('src/assets/images/airlines/0V.png'),
  VNE: require('src/assets/images/airlines/VNE.png'),
  VC: require('src/assets/images/airlines/VC.png'),
  V4: require('src/assets/images/airlines/V4.png'),
  VJ: require('src/assets/images/airlines/VJ.png'),
  VN: require('src/assets/images/airlines/VN.png'),
  VS: require('src/assets/images/airlines/VS.png'),
  VA: require('src/assets/images/airlines/VA.png'),
  V2: require('src/assets/images/airlines/V2.png'),
  VJT: require('src/assets/images/airlines/VJT.png'),
  UK: require('src/assets/images/airlines/UK.png'),
  VH: require('src/assets/images/airlines/VH.png'),
  VB: require('src/assets/images/airlines/VB.png'),
  Y4: require('src/assets/images/airlines/Y4.png'),
  VI: require('src/assets/images/airlines/VI.png'),
  V7: require('src/assets/images/airlines/V7.png'),
  VY: require('src/assets/images/airlines/VY.png'),
  EB: require('src/assets/images/airlines/EB.png'),
  WSG: require('src/assets/images/airlines/WSG.png'),
  WH: require('src/assets/images/airlines/WH.png'),
  SWN: require('src/assets/images/airlines/SWN.png'),
  NPT: require('src/assets/images/airlines/NPT.png'),
  KD: require('src/assets/images/airlines/KD.png'),
  WS: require('src/assets/images/airlines/WS.png'),
  WR: require('src/assets/images/airlines/WR.png'),
  WI: require('src/assets/images/airlines/WI.png'),
  WF: require('src/assets/images/airlines/WF.png'),
  WIG: require('src/assets/images/airlines/WIG.png'),
  WHS: require('src/assets/images/airlines/WHS.png'),
  WM: require('src/assets/images/airlines/WM.png'),
  '7W': require('src/assets/images/airlines/7W.png'),
  P5: require('src/assets/images/airlines/P5.png'),
  IW: require('src/assets/images/airlines/IW.png'),
  W7: require('src/assets/images/airlines/W7.png'),
  W6: require('src/assets/images/airlines/W6.png'),
  WL: require('src/assets/images/airlines/WL.png'),
  MF: require('src/assets/images/airlines/MF.png'),
  XOJ: require('src/assets/images/airlines/XOJ.png'),
  XP: require('src/assets/images/airlines/XP.png'),
  R3: require('src/assets/images/airlines/R3.png'),
  YC: require('src/assets/images/airlines/YC.png'),
  YE: require('src/assets/images/airlines/YE.png'),
  IY: require('src/assets/images/airlines/IY.png'),
  YT: require('src/assets/images/airlines/YT.png'),
  YG: require('src/assets/images/airlines/YG.png'),
  ZO: require('src/assets/images/airlines/ZO.png'),
  ORZ: require('src/assets/images/airlines/ORZ.png')
}

export default airlines
